<div class="bmc-migrate">
  <div class="bmc-migrate__start-action" *ngIf="!isLoading && (!status || status === 'NotStarted')">
    <h4 class="bmc-migrate__start-action__description">{{'MIGRATE_STAKEHOLDERS.DESCRIPTION_ACTION_START' | translate}}</h4>
    <bzg-button-primary class="bmc-migrate__start-action__button" (click)="startMigrate()">
      {{'MIGRATE_STAKEHOLDERS.MIGRATE_USERS_BUTTON' | translate}}
    </bzg-button-primary>
  </div>

  <div class="bmc-migrate__loading" *ngIf="isLoading">
    <bzg-loading [size]="'l'">
      {{'MIGRATE_STAKEHOLDERS.MIGRATING_STAKEHOLDERS' | translate}}
    </bzg-loading>
    <progress-bar [progress]="progress.currentPercentage" [color]="'#217D7E'"></progress-bar>
    <div class="bmc-migrate__container">
      <div class="bmc-migrate__content-left">
        <div class="bmc-migrate__left">
          <span class="bz-space--inline-s"><b>{{'MIGRATE_STAKEHOLDERS.PROGRESS_CURRENT_TASK' | translate}}:</b> {{'MIGRATE_STAKEHOLDERS.CURRENT_TASK_MIGRATE' | translate}}</span>
        </div>
        <div class="bmc-migrate__left">
          <span class="bz-space--inline-s"><b>{{'MIGRATE_STAKEHOLDERS.PROGRESS_TOTAL_USERS' | translate}}:</b> {{ progress.totalUsersToProcess }}</span>
        </div>
        <div class="bmc-migrate__left">
          <span class="bz-space--inline-s"><b>{{'MIGRATE_STAKEHOLDERS.PROGRESS_STAKEHOLDERS' | translate}}:</b>
            {{'MIGRATE_STAKEHOLDERS.PROGRESS_STAKEHOLDERS_RESULT' | translate: { "totalUsersProcessed": progress.totalUsersProcessed , "totalUsersToProcess": progress.totalUsersToProcess } }}
          </span>
        </div>
        <div class="bmc-migrate__left">
          <span class="bz-space--inline-s"><b>{{'MIGRATE_STAKEHOLDERS.PROGRESS_TASK_PERCENTAGE' | translate}}:</b> {{ progress.currentPercentage }} %</span>
        </div>
      </div>
      <div class="bmc-migrate__content-right" *ngIf="status === 'InProgress'">
        <bzg-button-secondary class="bmc-migrate__button-cancel" (click)="cancelMigrate()">
          {{'MIGRATE_STAKEHOLDERS.CANCEL_MIGRATION_BUTTON' | translate}}
        </bzg-button-secondary>
      </div>
    </div>
  </div>

  <div class="bmc-migrate__completed" *ngIf="!isLoading && status !== 'NotStarted' && status !== 'InProgress'">
    <div class="bmc-migrate__completed__container bz-color-border--theme-400" *ngIf="status === 'Done' || status === 'StartedDone'">
        <span>{{'MIGRATE_STAKEHOLDERS.MESSAGE_MIGRATION_COMPLETED' | translate}}</span>
    </div>
    <div class="bmc-migrate__completed__container bmc-migrate__completed__container--error" *ngIf="status === 'Error' || status === 'StartedError'">
      <bzg-icon class="bz-space--inline-m" [nameIcon]="'error-in-message'"
      [size]="30" [color]="'error'" class="bmc-migrate__icon-error"></bzg-icon>
        <span>{{'MIGRATE_STAKEHOLDERS.MIGRATE_STOP_ERROR' | translate}}</span>
    </div>
    <div class="bmc-migrate__completed__container bmc-migrate__completed__container--error" *ngIf="status === 'Canceled' || status === 'StartedCanceled'">
      <bzg-icon class="bz-space--inline-m" [nameIcon]="'error-in-message'"
      [size]="30" [color]="'error'" class="bmc-migrate__icon-error"></bzg-icon>
      <span>{{'MIGRATE_STAKEHOLDERS.MIGRATION_HAS_BEEN_CANCELED' | translate}}</span>
    </div>
    <div class="bmc-migrate__completed__description">
      <div class="bmc-migrate__completed__result-text">
        {{'MIGRATE_STAKEHOLDERS.RESULT_MIGRATION' | translate: { "totalUsersProcessed": progress.totalUsersProcessed , "totalUsersToProcess": progress.totalUsersToProcess } }}
      </div>
      <div class="bmc-migrate__completed__question-text">
        {{'MIGRATE_STAKEHOLDERS.QUESTION' | translate}}
      </div>
    </div>
    <bzg-button-primary class="bmc-migrate__start-action__button" (click)="startMigrate()">
      {{'MIGRATE_STAKEHOLDERS.MIGRATE_USERS_BUTTON' | translate}}
    </bzg-button-primary>
  </div>

</div>
